import { render } from "./Direct_Voucher.vue?vue&type=template&id=6f122ea8"
import script from "./Direct_Voucher.vue?vue&type=script&lang=js"
export * from "./Direct_Voucher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__